import DocumentCardLivePreview from '../shared/DocumentCardLivePreview';
import {
    PASSPORT_PREVIEW_PORTRAIT,
    PASSPORT_PREVIEW_LANDSCAPE,
    PASSPORT_PAGE_MM,
    passportMaxCopies,
} from './passportPageConstants';
import { computePassportCopyPairRects } from './passportToPdfEngine';

/**
 * The shared live page preview, wired to ICAO passport page geometry.
 * Same component NID-to-PDF uses; only the measurements differ.
 */
export default function PassportLivePreview(props) {
    return (
        <DocumentCardLivePreview
            {...props}
            cardMm={PASSPORT_PAGE_MM}
            previewPortrait={PASSPORT_PREVIEW_PORTRAIT}
            previewLandscape={PASSPORT_PREVIEW_LANDSCAPE}
            maxCopies={passportMaxCopies}
            computeCopyPairRects={computePassportCopyPairRects}
            i18nRoot="passportToPdf"
        />
    );
}
